import React from 'react'

import Label from 'components/Label'

import './InputCheckbox.scss'

export default function InputCheckbox({ children, label, onChange, ...others }: props) {
  function handleChange(e) {
    if (onChange) onChange(e)
  }

  return (
    <Label className="InputCheckbox">
      <input {...others} type="checkbox" className="uk-checkbox" onChange={handleChange} />
      {label}
    </Label>
  )
}



// WEBPACK FOOTER //
// ./src/components/InputCheckbox/InputCheckbox.js